export default "__VITE_ASSET__5c12781a__"